/** Join-код из ссылки приглашения. */
export function readJoinCode(): string | null {
  const sp = new URLSearchParams(window.location.search);
  const fromPath = (window.location.pathname.match(/^\/join\/([A-Za-z0-9]+)/) || [])[1];
  const fromSearch = sp.get('join');
  const ref = sp.get('vk_ref') || sp.get('ref') || '';
  const fromRef = ref.startsWith('join-') ? ref.slice('join-'.length) : '';
  const fromHash = (window.location.hash.match(/join=([A-Za-z0-9]+)/) || [])[1];
  return fromPath || fromSearch || fromRef || fromHash || null;
}

export function cleanJoinUrl() {
  const sp = new URLSearchParams(window.location.search);
  sp.delete('join');
  const ref = sp.get('vk_ref') || sp.get('ref') || '';
  if (ref.startsWith('join-')) {
    sp.delete('vk_ref');
    sp.delete('ref');
  }
  const search = sp.toString();
  const hash = window.location.hash.includes('join=') ? '' : window.location.hash;
  const path = /^\/join\//.test(window.location.pathname) ? '/' : window.location.pathname;
  window.history.replaceState(null, '', path + (search ? `?${search}` : '') + hash);
}

/** Достать код приглашения из текста (например, из буфера обмена). */
export function extractInviteCode(text: string): string | null {
  const byLabel = text.match(/Код:\s*([A-Za-z0-9]{4,12})/i);
  if (byLabel) return byLabel[1].toUpperCase();
  const byLink = text.match(/\/join\/([A-Za-z0-9]{4,12})/i);
  if (byLink) return byLink[1].toUpperCase();
  const bare = text.trim().match(/^([A-Za-z0-9]{4,12})$/);
  return bare ? bare[1].toUpperCase() : null;
}

/** Прочитать код приглашения из буфера обмена (лендинг кладёт туда код). */
export async function readInviteCodeFromClipboard(): Promise<string | null> {
  try {
    const text = await navigator.clipboard.readText();
    return extractInviteCode(text || '');
  } catch {
    return null;
  }
}

/** Ссылка-лендинг приглашения (параметры не срезаются — наш домен). */
export function buildInviteLink(code: string): string {
  return `https://app.nevessta.ru/join/${code}`;
}

/** Дип-линк в VK Mini App. На Android — intent://, чтобы открыть приложение ВК,
 *  а не веб-версию (обычный vk.com-линк из встроенного браузера уходит в «десктопную версию»). */
export function buildVkAppLink(code?: string | null): string {
  const q = code ? `?join=${code}&ref=join-${code}` : '';
  const web = `https://vk.com/app54822693${q}`;
  if (typeof navigator !== 'undefined' && /Android/i.test(navigator.userAgent)) {
    return `intent://vk.com/app54822693${q}#Intent;scheme=https;package=com.vkontakte.android;S.browser_fallback_url=${encodeURIComponent(web)};end`;
  }
  return web;
}
